var React = require('react');

function ChatFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.3291 21.1201C6.40137 21.1201 8.95898 20.0039 10.5586 18.8789C10.7256 18.7559 10.8662 18.7119 11.0068 18.7119C11.1211 18.7207 11.2266 18.7295 11.3232 18.7295C17.6602 18.7207 22.1953 15.2666 22.1953 10.5205C22.1953 5.97656 17.6514 2.32031 11.9912 2.32031C6.33105 2.32031 1.7959 5.97656 1.7959 10.5205C1.7959 13.3506 3.50098 15.8818 6.38379 17.4375C6.54199 17.5342 6.58594 17.666 6.50684 17.8242C5.99707 18.6768 5.14453 19.626 4.79297 20.0742C4.39746 20.5752 4.62598 21.1201 5.3291 21.1201Z","fill":"currentColor"}));
}

ChatFilled.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChatFilled;

ChatFilled.default = ChatFilled;
